import { DynamicSelect } from "@common/controls/Inputs/Select/component";
import { type InputTypeProps } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import getOptions from "@common/lib/options";
import React from "react";

type Props = InputTypeProps<string | null | undefined>;

const CountrySelect = (props: Props) => {
  const i18n = useI18n();
  const options = React.useMemo(() => getOptions(i18n), [i18n]);

  return <DynamicSelect {...props} fetchOptions={options.countries} sort="asc" />;
};
export default CountrySelect;
